import { render, staticRenderFns } from "./headBar.vue?vue&type=template&id=68f1aa16&scoped=true&"
var script = {}
import style0 from "./headBar.vue?vue&type=style&index=0&id=68f1aa16&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f1aa16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68f1aa16')) {
      api.createRecord('68f1aa16', component.options)
    } else {
      api.reload('68f1aa16', component.options)
    }
    module.hot.accept("./headBar.vue?vue&type=template&id=68f1aa16&scoped=true&", function () {
      api.rerender('68f1aa16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/headBar.vue"
export default component.exports